import React, { useState, useContext } from 'react'
import { M_Table, LoadingContext, NavigateContext, M_MessageBoard, M_DrawerTableTextField, M_Button, BufferService, M_Select, M_InputTextField, M_TextArea } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'

const Body = ({ dataChangeState, dataMovements, setDataMovements, t, optionsTrinomial }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
      {/* movimento falta de informação do cliente ✅ */}
      {dataChangeState === 1 && (
        <M_TextArea
          label={t('Notes')}
          value={dataMovements.Notes || ''}
          onChange={value => {
            setDataMovements(prev => ({
              ...prev,
              Notes: value.target.value
            }))
          }}
        />
      )}
      {/* movimento atribuição trinomio ✅ */}
      {dataChangeState === 3 && (
        <div>
          <div>
            {optionsTrinomial.map((elem, key) => (
              <M_DrawerTableTextField
                width="100%"
                key={key}
                tableLabel={elem.NormalizedName}
                label={elem.NormalizedName}
                required={elem.IsRequired}
                entity={elem.ForeignTableName}
                value={
                  dataMovements[elem.ForeignTableToPassId]
                    ? {
                      [elem.ForeignTableToPassId]: dataMovements[elem.ForeignTableToPassId],
                      [elem.ForeignKeyName]: dataMovements[elem.Name],
                    }
                    : null
                }
                filterField={elem.ForeignKeyName}
                labelFields={[elem.ForeignKeyName]}
                onSubmitValue={obj => {
                  if (obj) {
                    setDataMovements(prev => ({
                      ...prev,
                      [elem.Name]: obj[elem.ForeignKeyName],
                      [elem.ForeignTableToPassId]: obj[elem.ForeignTableToPassId],
                      Transport: obj.Transport || null,
                      TransportId: obj.TransportId || null,
                      Trailer: obj.Trailer || null,
                      TrailerId: obj.TrailerId || null,
                      Driver: obj.Driver || null,
                      DriverId: obj.DriverId || null,
                    }))
                  } else {
                    setDataMovements(prev => ({
                      ...prev,
                      [elem.Name]: null,
                      [elem.ForeignTableToPassId]: null,
                      Transport: null,
                      TransportId: null,
                      Trailer: null,
                      TrailerId: null,
                      Driver: null,
                      DriverId: null,
                    }))
                  }
                }}
                valueField={elem.ForeignTableToPassId}
              />
            ))}
          </div>

          {/* ---- CAMPOS EDITÁVEIS ABAIXO ---- */}
          <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <M_InputTextField
              value={dataMovements.Transport || ''}
              disabled
              label={t('Transport')}
            />

            <M_DrawerTableTextField
              width="100%"
              tableLabel={t('Trailer')}
              label={t('Trailer')}
              entity="Trailer"
              value={
                dataMovements?.TrailerId
                  ? { TrailerId: dataMovements.TrailerId, Trailer: dataMovements.Trailer }
                  : null
              }
              filterField="Trailer"
              labelFields={['Trailer']}
              onSubmitValue={obj =>
                setDataMovements(prev => ({
                  ...prev,
                  Trailer: obj ? obj.Trailer : null,
                  TrailerId: obj ? obj.TrailerId : null,
                }))
              }
              valueField="TrailerId"
              disabled={!dataMovements?.TransportId}
            />

            <M_DrawerTableTextField
              width="100%"
              tableLabel={t('Driver')}
              label={t('Driver')}
              entity="Driver"
              value={
                dataMovements?.DriverId
                  ? { DriverId: dataMovements.DriverId, Driver: dataMovements.Driver }
                  : null
              }
              filterField="Driver"
              labelFields={['Driver']}
              onSubmitValue={obj =>
                setDataMovements(prev => ({
                  ...prev,
                  Driver: obj ? obj.Driver : null,
                  DriverId: obj ? obj.DriverId : null,
                }))
              }
              valueField="DriverId"
              disabled={!dataMovements?.TransportId}
            />
          </div>
        </div>
      )}
      {/* movimento atribuir numero de contentor ✅ */}
      {(dataChangeState === 6 || dataChangeState === 8) && (
        <M_InputTextField
          label={t("ContainerNumber")}
          value={dataMovements.ContainerNumber || ''}
          onChange={value => {
            setDataMovements(prev => ({
              ...prev,
              ContainerNumber: value.target.value
            }))
          }}
        />
      )}
      {/* movimento incidencia */}
      {dataChangeState === 9 && (
        <div>
          <M_DrawerTableTextField
            width="100%"
            tableLabel={t('Incidence')}
            label={t('Incidence')}
            entity="ServiceOrderStateReason"
            value={
              dataMovements?.ReasonId
                ? { ReasonId: dataMovements.ReasonId, Name: dataMovements.Name }
                : null
            }
            filterField="Name"
            labelFields={['Name']}
            onSubmitValue={obj =>
              setDataMovements(prev => ({
                ...prev,
                Name: obj ? obj.Name : null,
                ReasonId: obj ? obj.ReasonId : null,
              }))
            }
            valueField="ReasonId"
          />
          <M_TextArea
            label={t('Notes')}
            value={dataMovements.Notes || ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                Notes: value.target.value
              }))
            }}
          />
        </div>
      )}
      {/* movimento atribuir pré-levante */}
      {dataChangeState === 10 && (
        <div>
          <M_DrawerTableTextField
            width="100%"
            tableLabel={t('Address')}
            label={t('AddressPreLevante')}
            entity="Address"
            value={
              dataMovements?.PreLevanteAddressId
                ? {
                  AddressId: dataMovements.PreLevanteAddressId,
                  AddressCode: dataMovements.PreLevanteAddress
                }
                : null
            }
            filterField="AddressCode"
            labelFields={['AddressCode']}
            onSubmitValue={obj =>
              setDataMovements(prev => ({
                ...prev,
                PreLevanteAddress: obj ? obj.AddressCode : null,
                PreLevanteAddressId: obj ? obj.AddressId : null,
              }))
            }
            valueField="AddressId"
            FILTER={"AddressTypeId eq 2"}
          />

          <M_InputTextField
            label={t("PreLevanteDate")}
            type="datetime-local"
            value={dataMovements.DateTime || ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                PreLevanteDate: value.target.value
              }))
            }}
          />
        </div>
      )}
      {/* movimento subContratar */}
      {dataChangeState === 13 && (
        <M_InputTextField
          label={t("SubcontractorName")}
          value={dataMovements.SubcontractorName || ''}
          onChange={value => {
            setDataMovements(prev => ({
              ...prev,
              SubcontractorName: value.target.value
            }))
          }}
        />
      )}
    </div>
  )
}

export default function ExecutionBoard({ roles }) {

  const [line, setLine] = useState(null)
  const [modalChangeState, setModalChangeState] = useState(false)
  const [dataMovements, setDataMovements] = useState({})
  const [dataChangeState, setDataChangeState] = useState('')
  const [optionsState, setOptionsState] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [historyMovements, setHistoryMovements] = useState([])
  const [modalHistoryMovements, setModalHistoryMovements] = useState(false)
  const getMovementType = new BufferService('ServiceOrderStateMovementType')
  const submitMovement = new BufferService('ServiceOrderChangeState/change-state')
  const bufferServiceHistoryMovements = new BufferService('ServiceOrderChangeState')
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const { t } = useTranslation()

  const optionsTrinomial = [
    { Name: 'Trinomial', NormalizedName: t('Trinomial'), type: 'string', IsDisabled: false, IsRequired: true, IsHiddenList: false, ForeignTableToPassId: 'TrinomialAssignId', ForeignTableName: 'AvailableTrinomialBoardView', ForeignKeyName: 'Transport' },
  ]

  const changeState = () => {
    if (line) {
      ctx.setIsLoad(true)
      const filter = `?$filter=ServiceOrderStateId eq ${line[0].ServiceOrderStateId} &$orderby=ServiceOrderMovementTypeId asc`

      getMovementType.filter(filter).then(response => {
        if (response.name === 'AxiosError') {
          ctx.toastMessages('error', response.response.data.Errors.toString(), '')
          ctx.setIsLoad(false)
          return
        }
        setOptionsState(response.Items)
        setModalChangeState(true)
        ctx.setIsLoad(false)
      })

    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }

  const submitChangeState = () => {
    setDataChangeState('')
    const tempObject = {
      ServiceOrderId: line[0].ServiceOrderId,
      ServiceOrderMovementTypeId: dataChangeState,
      MovDate: new Date().toISOString(),
      ...dataMovements
    }
    if (tempObject.ServiceOrderMovementTypeId === '') {
      ctx.toastMessages("error", '', t("SelectOneMovement"))
      return
    }

    submitMovement.post(tempObject).then(response => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors.toString(), '')
        return
      }
      ctx.toastMessages('success', t("ChangeStateSuccess"), '')
      setDataMovements({})
      setModalChangeState(false)
      setRefresh(true)
    })
  }

  const viewOrderService = () => {
    if (line) {
      const current = ctx.passValue instanceof Map ? ctx.passValue : new Map()
      const newMap = new Map(current)
      newMap.set("lines", line[0])

      ctx.setPassValue(newMap)

      ctx2.newTab('viewOrderService', `${t("NumberOrder")} #${line[0].ServiceOrderId}`)
    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }

  const viewHistoryMovements = () => {
    if (line) {
      ctx.setIsLoad(true)
      bufferServiceHistoryMovements.filter(`?filter=serviceOrderId eq ${line[0].ServiceOrderId}`).then((respHistory) => {
        if (respHistory.name === 'AxiosError') {
          ctx.toastMessages('error', respHistory.response.data.Errors[0], '')
          return
        }
        setHistoryMovements(respHistory.Items)
        setModalHistoryMovements(true)
        ctx.setIsLoad(false)
      })
    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }

  return (
    <div>
      <M_Table
        entityName={'ServiceOrderExecutionBoardView'}
        rolePermissions={roles}
        filtersOnTable
        refresh={refresh}
        setRefresh={setRefresh}
        selectSingle
        onPassLine={(line) => {
          if (!line || (Array.isArray(line) && line.length === 0)) {
            setLine(null)
          } else {
            setLine(line)
          }
        }}
        extraButtons={[
          { label: t('ChangeMovement'), element: 'default', source: '/icons/svgsDaNet/arrows-shuffle.svg', style: {}, command: () => { changeState() } },
          { label: t('OrderServiceView'), element: 'default', source: '/icons/svgsDaNet/eye-blue.svg', style: {}, command: () => { viewOrderService() } },
          { label: t('HistoryMovements'), element: 'default', source: '/icons/svgsDaNet/history.svg', style: {}, command: () => { viewHistoryMovements() } }
        ]}
      />

      <M_MessageBoard
        open={modalChangeState}
        title={t('ChangeMovement')}
        onClose={() => setModalChangeState(false)}
        body={<div style={{ minWidth: '300px' }}>
          <M_Select
            label={t('SelectMovement')}
            options={optionsState.map(state => ({
              label: state.MovementType,
              value: state.ServiceOrderMovementTypeId
            }))}
            value={dataChangeState || ''}
            onChange={value => {
              setDataChangeState(value.target.value)
              setDataMovements({})
            }}
          />
          <div>
            <Body
              dataChangeState={dataChangeState}
              dataMovements={dataMovements}
              setDataMovements={setDataMovements}
              optionsTrinomial={optionsTrinomial}
              t={t}
            />

          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '10px', gap: '5px' }}>
            <img src="/icons/svgsDaNet/alert-triangle.svg" alt="alert" style={{ width: '20px' }} />
            {t("InfoSendEmailChangeState")}
          </div>
        </div>}
        footer={<div className='divFooterAlertsOrderService'>
          <M_Button
            backgroundColor={'var(--color-red)'}
            label={t("Close")}
            labelColor={'var(--color-white)'}
            onClick={() => {
              setModalChangeState(false)
              setDataChangeState('')
              setDataMovements({})
            }}
          />
          <M_Button
            backgroundColor={'var(--color-green)'}
            label={t("Save")}
            labelColor={'var(--color-white)'}
            onClick={submitChangeState}
          />
        </div>}
      />

      <M_MessageBoard
        open={modalHistoryMovements}
        title={t('HistoryMovements')}
        onClose={() => setModalHistoryMovements(false)}
        minWidth={'80%'}
        body={
          historyMovements.length !== 0 ? (
            <div style={{ width: '100%' }}>
              <div className='tableHistoryMovementsOrderService'>
                <div style={{ textAlign: 'center' }}>{t("Status")}</div>
                <div style={{ textAlign: 'center' }}>{t("DateChange")}</div>
                <div style={{ textAlign: 'center' }}>{t("Trinomial")}</div>
                <div style={{ textAlign: 'center' }}>{t("Notes")} </div>
                <div style={{ textAlign: 'center' }}>{t("MovementName")}</div>
                <div style={{ textAlign: 'center' }}>{t("CreatedBy")} </div>
              </div>
              <div>
                {historyMovements?.map((elem, key) => (
                  <div key={key} className='divRowHistoryMovementsOrderService'>
                    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                      <div style={{ backgroundColor: elem.ServiceOrderWorkflowFromStateColor || "#000000" }} className='divIndicatorStatusHistoryMovementsOrderService'>
                        {elem.ServiceOrderWorkflowFromState}
                      </div>
                      <span>→</span>
                      <div style={{ backgroundColor: elem.ServiceOrderWorkflowToStateColor || "#000000" }} className='divIndicatorStatusHistoryMovementsOrderService'>
                        {elem.ServiceOrderWorkflowToState}
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      {new Date(elem.MovDate).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    </div>
                    <div style={{ textAlign: 'center' }}>{elem.TransportName ? `${elem.TrailerName} + ${elem.DriverName} + ${elem.TransportName}` : t("NoData")}</div>
                    <div style={{ textAlign: 'center' }}>{elem.Notes || t("NoData")}</div>
                    <div style={{ textAlign: 'center' }}>{elem.ServiceOrderMovementTypeName || t("NoData")}</div>
                    <div style={{ textAlign: 'center' }}>{elem.CreatedBy || t("NoData")}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : t("NoData")
        }
        footer={
          <M_Button
            backgroundColor={'var(--color-red)'}
            label={t("Close")}
            labelColor={'var(--color-white)'}
            onClick={() => {
              setModalHistoryMovements(false)
              setHistoryMovements([])
            }}
          />
        }
      />
    </div>
  )
}